<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout wrap mt-4>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="First Name*" dense outlined v-model="updatedUser.firstName"></v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Last Name*" outlined dense v-model="updatedUser.lastName"></v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Email*" dense outlined v-model="updatedUser.email"></v-text-field>
      </v-flex>
      <v-flex v-if="selectCustomer" xs12 pl-2 pr-2>
        <v-autocomplete
          dense
          v-model="user.company"
          :items="customers"
          item-text="name"
          item-value="_id"
          label="Select customer*"
          outlined
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Phone #*" outlined dense v-model="updatedUser.phoneNumber"></v-text-field>
      </v-flex>
      <v-flex xs12 pl-2 pr-2>
        <v-text-field label="Title" dense outlined v-model="updatedUser.title"></v-text-field>
      </v-flex>
      <!-- <v-flex xs12 pl-2 pr-2>
        <v-switch
          v-model="updatedUser.approved"
          :label="
            user.approved ? 'User can access app' : 'User cannot access app'
          "
        />
      </v-flex>-->
    </v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn :disabled="!validUser" @click="$emit('save', updatedUser)" color="primary">Save</v-btn>
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import ActionModal from "./ActionModal";
import isValidEmail from "@/modules/isValidEmail";
import UserModal from "@/components/shared/modals/UserModal";
export default {
  name: "UserModal",
  props: {
    user: {
      type: Object,
      default: () => {
        return {
          email: null,
          firstName: null,
          lastName: null,
          phoneNumber: null,
          title: null,
          company: null,
        };
      },
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    customers: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectCustomer: {
      type: Boolean,
      default: false,
    },
    action: {
      type: String,
      required: true,
    },
  },
  components: {
    ActionModal,
  },
  data() {
    return {
      company: null,
    };
  },
  computed: {
    validUser() {
      if (this.selectCustomer) {
        return (
          this.user.firstName &&
          this.user.lastName &&
          this.user.email &&
          this.user.company &&
          this.user.phoneNumber &&
          this.user.phoneNumber.length &&
          isValidEmail(this.user.email)
        );
      } else {
        return (
          this.user.firstName &&
          this.user.lastName &&
          this.user.email &&
          this.user.phoneNumber &&
          this.user.phoneNumber.length &&
          isValidEmail(this.user.email)
        );
      }
    },
    updatedUser() {
      const { user } = this;
      return user;
    },
    open() {
      return this.isOpen;
    },
  },
  methods: {
    close() {
      this.$emit("update:userModal", false);
    },
  },
};
</script>
